import type { ExportJobStatus } from "@/types/api";

export type ExportStatusVariant = "running" | "ready" | "failed" | "neutral";

export function exportStatusVariant(status: ExportJobStatus): ExportStatusVariant {
  if (status === "PENDING" || status === "RUNNING") return "running";
  if (status === "SUCCESS") return "ready";
  if (status === "FAILED") return "failed";
  return "neutral";
}

export function exportStatusLabel(status: ExportJobStatus): string {
  if (status === "PENDING" || status === "RUNNING") return "Running";
  if (status === "SUCCESS") return "Ready";
  if (status === "FAILED") return "Failed";
  if (status === "CANCELED") return "Canceled";
  return status;
}

export function isExportActive(status: ExportJobStatus): boolean {
  return status === "PENDING" || status === "RUNNING";
}
